<template>
    <v-col cols="12" sm="12" class="visit-container" @click="$emit('show-visit')">
      <v-card style="border-radius:0; padding: 12px;">
        <v-row style="margin:0; margin-bottom: 12px;">
          <v-col cols="5" style="padding:0">
            <div :style="visitTypeStyle">{{ visit.visit_type.label }}</div>
          </v-col>
          <v-col v-if="$store.state.app_display_scheme" cols="1" style="padding:0; display: flex; align-items: center; justify-content: center;">
            <v-img v-if="visitTechReq.request.scheme=='asistencia'" class="ml-2" contain src="../icons/asistencia.png" height="20"></v-img>
            <v-img v-if="visitTechReq.request.scheme=='cliente-final'" class="ml-2" contain src="../icons/clientefinal.png" height="20"></v-img>
            <v-img v-if="visitTechReq.request.scheme=='corpo'" class="ml-2" contain src="../icons/corporativo.png" height="20"></v-img>
            <v-img v-if="visitTechReq.request.scheme=='fletes'" class="ml-2" contain src="../icons/fletes.png" height="20"></v-img>
            <v-img v-if="visitTechReq.request.scheme=='inmobiliaria'" class="ml-2" contain src="../icons/inmobiliaria.png" height="20"></v-img>
          </v-col>
          <v-col cols="3" style="padding:0; display: flex; align-items: center;">
            <div style="margin-left: 12px; font-weight: bold;">ID: {{ visitTechReq.request.id }}</div>
          </v-col>

        </v-row>
        <v-row>
          <v-col cols="12" style="padding:0 display: flex; align-items: center; justify-content: flex-start;">
            <div style="margin-right: 24px;"><b>HORA DE INICIO:</b> {{ visit.arrival_time }}</div>
          </v-col>
        </v-row>
        <v-row v-if="showDate" align="center" style="margin: 0 12px; text-transform: capitalize;">
          {{ formatDate(visit.visit_date) }}
        </v-row>
        <v-row v-if="$store.state.app_display_username && visitTechReq.request.client" align="center" style="margin: 0 12px; font-weight: bold;">
          {{ visitTechReq.request.client.last_name }}, {{ visitTechReq.request.client.first_name }}
        </v-row>
        <v-row align="center" style="font-weight: bold; text-transform: capitalize; margin: 0 0 12px;">
        {{ visitTechReq.request.service.name }}
        </v-row>
        <v-row align="center" style="margin: 0">
          {{ visitTechReq.request.full_address }}
        </v-row>
      </v-card>
    </v-col>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    visit: Object,
    showDate: String
  },
  computed: {
    visitTechReq: function () {
      const visitTechReq = this.$store.state.user_techReqs.find(element => element.id === this.visit.request_technician)
      return visitTechReq
    },
    visitTypeStyle: function () {
      const style = `
        background-color:${this.visit.visit_type.backgroundColor};
        color:${this.visit.visit_type.color};
        padding: 6px;
        font-size: 14px;
        display: flex;
        justify-content: center;
      `
      return style
    }
  },
  methods: {
    formatDate (date) {
      const _date = new Date()
      const today = moment(_date).format('YYYY-MM-DD')
      if (date === today) {
        return 'Hoy'
      } else {
        return moment(date, 'YYYY-MM-DD').format('dddd DD MMMM, YYYY')
      }
    }
  }
}
</script>

<style scoped>
  @media(max-width: 959px){
    .visit-container {
      padding: 12px 0;
      background: #EEEEEE;
    }
  }
</style>
